// Foundations
import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Models
import { CanDeactivateComponent } from '../../models/can-deactivate-component.model';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { DialogService } from '../../services/dialog.service';

// Components
import { ChangePasswordComponent } from '../../components/change-password/change-password.component';

@Component({
  selector: 'app-change-password-page',
  templateUrl: './change-password-page.component.html',
  styleUrls: ['./change-password-page.component.scss'],
})
export class ChangePasswordPageComponent
  implements OnInit, CanDeactivateComponent
{
  @HostBinding('class') class = 'page-config';
  @ViewChild('cpPage', { static: false }) cpPage: ChangePasswordComponent;

  constructor(
    private _analytics: AnalyticsService,
    private dialogService: DialogService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Client Portal - Change Password');
  }

  ngOnInit(): void {
    this._analytics.logScreen('changePasswordPage');
  }
  canDeactivate() {
    if (this.cpPage && this.cpPage.form && !this.cpPage.form.pristine) {
      return this.dialogService.confirmDiscard();
    }
    return true;
  }
}
